module.exports = __webpack_public_path__ + "img/logo.ce3cb627.svg";